import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faQuestion } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton, BFormDatalist, BFormDatepicker, BFormInput, BInputGroup, BInputGroupAppend, BModal, } from "bootstrap-vue";
import { capitalize } from "lodash";
import { computed, ref, watch } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FilterMenuInput',
    props: {
        name: null,
        identifier: null,
        error: null,
        filter: null,
        filters: null
    },
    emits: ["change", "on-enter", "on-esc"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faQuestion);
        const propValue = computed(() => props.filters[props.name]);
        const localValue = ref(propValue.value);
        const helpToggle = ref(false);
        const modalTitle = `${capitalize(props.filter.placeholder)} Help`;
        function hasError(field) {
            if (props.error && props.error.index == field) {
                return props.error.typeError || props.error.msg;
            }
            return "";
        }
        function onHelp(_, value) {
            helpToggle.value = false;
            localValue.value = value;
        }
        watch(() => localValue.value, (newFilter) => {
            emit("change", props.name, newFilter);
        });
        watch(() => propValue.value, (newFilter) => {
            localValue.value = newFilter;
        });
        return { __sfc: true, props, emit, propValue, localValue, helpToggle, modalTitle, hasError, onHelp, faQuestion, FontAwesomeIcon, BButton, BFormDatalist, BFormDatepicker, BFormInput, BInputGroup, BInputGroupAppend, BModal };
    }
});
